// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"5e0054ff","218":"298e1952","340":"9b0f2249","453":"bba4dbea","841":"7c12740a","967":"99605993"}[chunkId] + ".chunk.js";
};